

import {Component, Vue} from 'vue-property-decorator';
import {integrityApi} from "@/api/integrity";
import {IPage} from "@/js/page"
import vuePrototype from "@/common/prototype";
import baseUrl, {imageUrl} from "@/constants";
import echarts from "echarts";
import {onMounted} from "vue";
import QijuTianXieZhiNan from "@/components/QiJuTianXieZhiNan.vue";
import ckeditor from "@/components/AllCkeditorComponent.vue";
import {noticeApi} from "@/api/notice.ts";
import PublicityDialog from "@/views/integrity/publicityDialog.vue";
import IntegrityDemoDialog from "@/views/integrity/integrityDemoDialog.vue";
import Video from "@/components/Video.vue";
@Component({
  name: "integrityIndex",
  components: {IntegrityDemoDialog, PublicityDialog, ckeditor, QijuTianXieZhiNan, Video},
})
export default class Home extends Vue {
  baseUrl = baseUrl
  imageUrl = imageUrl
  finishNum = 0;
  incompleteNum = 0;
  thisYearNum = 0; // 今年的公示数量
  listData = [];
  gsData =[] ;
  demoData =[];
  userData = null as any;
  showCommitment = true;
  showCommitmentChart = true;
  listParam: IPage = {
    size: 100,
    current: 1,
  };
  adminAgency = {name: '', userMobile: ''};
  created() {
      // this.list();
      this.listGs();
      this.loadData();
  }

  mounted() {
    // 判断使用单位不展示承诺公示，区县级不展示柱状图
    this.getUserData();
  }

  //获取登录人数据
  getUserData(){
    this.userData = this.$store.state.AuthedUser;
    if (this.userData.level === '0003') {
      this.showCommitmentChart = false;
    }
    // 获取柱状图
    this.getBarData();
    // 获取通知公告
    this.getNoticeList();
    // 获取行政机构
    this.getAdminAgency();
  }

  // 获取行政机构
  getAdminAgency() {
    integrityApi.getAdministrativeAgency().then(r => {
      if (r.data.result == 0) {
        const rData = r.data.data;
        this.adminAgency = rData;
      }
    })
  }

  // 获取柱状图数据
  getBarData() {
    //  state 1 待审核    3是已公示   total 当年公示数量
    integrityApi.listStatistics().then(r => {
      if (r.data.result == 0) {
        const chartObj = [] as any;
        const chartName = [];
        const chartData1 = [];
        const chartData2 = [];
        const rData = r.data.data;
        // 如果是使用单位
        if (!rData) {
          this.showCommitment = false;
          return;
        }
        for(const r of rData){
          const obj = chartObj.find((e: any) => e.name == r.name);
          if (!obj) {
            const obj1 = {
              name: r.name,
              finish: 0,
              incomplete: 0,
              thisYear: 0
            };
            if (r.state === 1) {
              obj1.incomplete = r.count;
              this.incompleteNum += r.count;
            }
            if (r.state === 3) {
              obj1.finish = r.count;
              this.finishNum += r.count;
              obj1.thisYear = r.total;
              this.thisYearNum += r.total
            }
            chartObj.push(obj1)
          } else {
            if (r.state === 1) {
              obj.incomplete = r.count;
              this.incompleteNum += r.count;
            }
            if (r.state === 3) {
              obj.finish = r.count;
              this.finishNum += r.count;
              obj.thisYear = r.total;
              this.thisYearNum += r.total
            }
          }
        }
        for(const c of chartObj){
          chartName.push(c.name);
          chartData1.push(c.finish);
          chartData2.push(c.thisYear);
        }
        this.initChart(chartName, chartData1, chartData2)
      }
    })
  }

  // 加载柱状图
  initChart(chartName: any,chartData1: any,chartData2: any) {
    const myChart = echarts.init(this.$refs.bar1);
    myChart.setOption({
      tooltip: {},
      legend: {},
      xAxis: {
        data: chartName,
        type: 'category',
        axisLabel: {
          interval: 0 ,
          formatter: function (value: any) {
            let text,
                length = 8; // 文字显示长度
            if (value.length>length) {
              text = value.slice(0,length) + '…'
            } else {
              text = value
            }
            return text.split("").join("\n") //垂直显示
          },
        }
      },
      yAxis: {},
      series: [
        {
          name: '公示数量',
          type: 'bar',
          data: chartData1,
          barWidth: '20',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                offset: 0,
                color: "#1268f3" // 0% 处的颜色
              }, {
                offset: 0.6,
                color: "#08a4fa" // 60% 处的颜色
              }, {
                offset: 1,
                color: "#01ccfe" // 100% 处的颜色
              }], false),
            },
          },
          label: {
            show: true, //开启显示
            position: 'top', //在上方显示
            textStyle: { //数值样式
              color: 'red',
              fontSize: 16
            }
          }
        },
        {
          name: '今年公示数量',
          type: 'bar',
          data: chartData2,
          barWidth: '20',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                offset: 0,
                color: "#FF5B5B" // 0% 处的颜色
              }, {
                offset: 0.6,
                color: "#FF7A7A" // 60% 处的颜色
              }, {
                offset: 1,
                color: "#FF9B9B" // 100% 处的颜色
              }], false)
            },
          },
          label: {
            show: true, //开启显示
            position: 'top', //在上方显示
            textStyle: { //数值样式
              color: 'red',
              fontSize: 16
            }
          }
        }
      ]
    });
  }
  list() {
    const params = {
      ...this.listParam
    }
    integrityApi.list(params).then(r => {
      if(r.data.result == 0){
        const rData = r.data.data;
        this.listData = rData.records;

        this.$nextTick(()=>{
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.doLayout();
          }
        })
      }
    })
  }

  listGs(){
    const params = {
      ...this.listParam,
      state:3
    }
    integrityApi.list(params).then(r => {
      if(r.data.result == 0){
        const rData = r.data.data;
        this.gsData = rData.records;

        this.$nextTick(()=>{
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.doLayout();
          }
        })
      }
    })
  }
  loadData(){

    const params = {
      ...this.listParam
    }
    integrityApi.listCultural(params).then((r: any) => {
      const res = r.data;

      if(res.result === 0){
        this.demoData = res.data.records;


      }
    });
  }
  toList(url: string) {
    this.$router.push(url);
  }

  // 通知公告**********************************************************
  private showInfoDialog = false;
  private noticeList = [];
  private noticeDefault = {
    title: '',
    createTime: '',
    content: ''
  }
  private noticeInfo = Object.assign({}, this.noticeDefault);

  getNoticeList() {
    noticeApi.pageList({current: 1, size: 5}).then((r: any) => {
      const res = r.data;
      if(res.result === 0){
        this.noticeList = res.data.records;
      }
    });
  }
  onToDetail(row :any){
    this.noticeInfo = Object.assign({}, this.noticeDefault, row);
    this.showInfoDialog = true;
  }
  // 通知公告end**********************************************************

  // 诚信计量****************************************
  publicityDetail(row: any) {
    (this.$refs.publicityDialogRef as any).setData(row)
  }
  // 诚信计量end****************************************
  // 文化巡礼****************************************
  showDemoDetil(row: any) {
    (this.$refs.integrityDemoDialogRef as any).setData(row)
  }
  // 文化巡礼end****************************************
}
